module.exports = __webpack_public_path__ + "static/img/weather6.eb5dbbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weather6.png
// module id = t+9o
// module chunks = 0